import {createEnvironmentSlice} from "@/data/create_environment_slice.js";

export const {reducer, remove, replace, update} = createEnvironmentSlice("Reservation");
